import React, {createContext, useState, useContext, ReactNode, useEffect} from 'react';
import {MamSummary, MamSummaryPageState} from '../types/mamTypes';
import {useMamInformation} from "./MamInformation";
interface MamSummaryProps {
    summary: MamSummary;
    setSummary: (summary: MamSummary) => void;
    pagesSummary: MamSummaryPageState;
    setPagesSummary: (pageState: MamSummaryPageState) => void;
    setGroupClipPage: (eventId: string, pageNumber: number, pageSize: number) => void;
}

const MamSummaryContext = createContext<MamSummaryProps | undefined>(undefined);

const MamSummaryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const [summary, setSummary] = useState<MamSummary>({
        competition: "",
        match: [],
        groupClip: [],
        entityName: "",
        matchDay: [],
    });

    const [pagesSummary, setPagesSummary] = useState<MamSummaryPageState>({
        match: {},
        groupClip: {},
        entityName: {},
        matchDay: {},
        competition: {}
    });


    function setGroupClipPage(eventId: string, pageNumber: number, pageSize: number){
        const tempPagesSummary = {...pagesSummary};
        tempPagesSummary.groupClip[eventId] = {size: pageSize, number: pageNumber};
        setPagesSummary(tempPagesSummary);
    }

    return (
        <MamSummaryContext.Provider value={{summary, setSummary, pagesSummary, setPagesSummary, setGroupClipPage}}>
            {children}
        </MamSummaryContext.Provider>
    );
};




// Custom hook to use the filter context
const useMamSummary = () => {
    const context = useContext(MamSummaryContext);
    if (context === undefined) {
        throw new Error('useMamSummary must be used within a MamSummary provider');
    }
    return context;
};

export { MamSummaryProvider, useMamSummary };